export enum HardCodedSalesItemId {
  // WC
  WheelChangeLargeCar = 7,
  WheelChangeSmallCar = 8,
  WheelChangeVan = 90,

  // Addon WC
  RimWashSmallCar = 9,
  RimWashLargeCar = 10,
  HelpToCarryTires = 25,

  // TH

  // New customer
  TireHotelNewCustomerSmallCar = 26,
  TireHotelNewCustomerLargeCar = 27,
  TireHotelNewCustomerOnlyStorage = 99,

  // Renewal
  TireHotelRenewal = 98,

  // TH cancel with WC
  TireHotelCancelHomeDeliveryAndWheelChange = 96,

  // TH cancel without WC
  TireHotelCancelHomeDelivery = 95,

  // TH addons
  TireHotelPickup = 51,
  TireHotelPickupEx = 109,

  // Random
  RepairOfPuncture = 8019,

  // Outside
  OutsideWashExtraDirty = 57,
  OutsideWashPlusLargeCar = 21,
  OutsideWashPlusSmallCar = 20,
  OutsideWashPremiumSmallCar = 22,
  OutsideWashPremiumLargeCar = 23,
  OutSideWashStandardLargeCar = 72,
  OutSideWashStandardSmallCar = 2,

  // Inside
  InsideWashExtraDirty = 29340,
  InsideWashPlusSmallCar = 16,
  InsideWashPlusLargeCar = 17,
  InsideWashPremiumSmallCar = 18,
  InsideWashPremiumLargeCar = 19,
  InsideWashVan = 110,
  InsideWashStandard = 1
}
